module.exports = __webpack_public_path__ + "media/images/dashboard/wedding_styles/beach1-7366ef7e5b9cf187874ff236b1a4783a.jpg";